import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ArrowIcon from '../assets/svgs/Group 3 (6).svg';
import WhiteArrowIcon from '../assets/svgs/white-arrow.svg';
import GradientArrowIcon from '../assets/svgs/Group 3 (5).svg';
import '../components-css/service-page.scss';
import designingImg from '../assets/svgs/our-designing-process.svg';
import designingImg2 from '../assets/svgs/Group 34405.svg';
import designingImg3 from '../assets/svgs/Group 34412.svg';
import digitalMarketingImg8 from '../pngs/Group 105314.png';
import digitalMarketingImg7 from '../pngs/Group 105316.png';
import digitalMarketingImg6 from '../pngs/Group 105318.png';
import digitalMarketingImg5 from '../pngs/Group 105320.png';
import digitalMarketingImg4 from '../pngs/Group 105322.png';
import digitalMarketingImg3 from '../pngs/Group 1000004994.png';
import digitalMarketingImg2 from '../pngs/Group 105326.png';
import digitalMarketingImg1 from '../pngs/Group 105328.png';
import toolsUsedImg from '../pngs/Group 105133.png';
import chooseImg from '../pngs/Rectangle 394.png';
import OurClients from '../components/OurClients';
import circleArrow from '../assets/svgs/circle-arrow.svg';
import Faq from '../components/Faq';
import axios from 'axios';
import { BASE_URL } from '../config';
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet-async';

const seoData = {
  'branding-uiux-designing': {
    title: 'Branding & UI/UX Design Services for Web & Mobile App',
    description: 'Omka Tech provides top-notch UI and UX design services to bring best to your application. We will help you develop an existing UI/UX design.',
    link: 'https://omkatech.com/services/branding-uiux-designing'
  },
  'web-design-development': {
    title: 'Omka Tech-Best Website Design & Development Company',
    description: 'Omka Tech is a professional web development company offering custom website design services, website development services, and enterprise solutions.',
    link: 'https://omkatech.com/services/web-design-development'
  },
  'mobile-app-development': {
    title: 'Top Notch Mobile App Development Services for Android & iOS',
    description: 'Omka Tech is a leading mobile app development company in the US and Canada, offering mobile app development services for Android and iOS platforms.',
    link: 'https://omkatech.com/services/mobile-app-development'
  },
  'enterprise-software-development': {
    title: 'Boost Your Business with Enterprise Software Solutions',
    description: 'Omka Tech is a trusted enterprise software development company offering enterprise software development services and enterprise software solutions.',
    link: 'https://omkatech.com/services/enterprise-software-development'
  },
  'business-consultation': {
    title: 'Business Consultant Service | Business IT Consulting Company',
    description: 'Omka Tech is a business consultant company offering business consulting services and business IT consulting to support enterprise growth and success.',
    link: 'https://omkatech.com/services/business-consultation'
  },
  'digital-marketing': {
    title: 'Digital Marketing Services | SEO, PPC & Social Media Agency',
    description: 'Looking for a trusted digital marketing company for SEO optimization service, website design, PPC service, and Social Media. Discover our services today!',
    link: 'https://omkatech.com/services/digital-marketing'
  },
  'it-managed-services': {
    title: 'IT Managed Services Provider | Managed IT Services',
    description: 'Omka Tech is an IT managed services provider offering managed IT services and IT infrastructure management for secure, reliable business growth.',
    link: 'https://omkatech.com/services/it-managed-services'
  }
};

const ServicePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const service = seoData[params.slug];

  const [isHovered, setIsHovered] = useState(false);
  const [serviceData, setServiceData] = useState(null);
  const [showSlider, setShowSlider] = useState(false);

  const getPlainText = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  const digitalMarketingServices = [
    {
      image: digitalMarketingImg1,
      title: 'Search Engine Optimization (SEO)',
      description: 'Optimize your website to rank higher, drive organic traffic, and improve visibility. From keyword research to on-page and off-page SEO, we keep you ahead of the competition.'
    },
    {
      image: digitalMarketingImg2,
      title: 'Social Media Optimization (SMO)',
      description: 'Strengthen your social media presence by optimizing your profiles and content for better engagement and visibility across platforms like Facebook, Instagram, LinkedIn, and Twitter.'
    },
    {
      image: digitalMarketingImg3,
      title: 'Social Media Marketing (SMM)',
      description: 'Run targeted ad campaigns on social media platforms to reach your ideal audience, boost engagement, and drive conversions.'
    },
    {
      image: digitalMarketingImg4,
      title: 'E-Commerce Ads',
      description: 'Launch data-driven paid ad campaigns on Google and Amazon, ensuring your products and services reach the right audience at the right time for maximum ROI.'
    },
    {
      image: digitalMarketingImg5,
      title: 'Email Marketing',
      description: 'Build lasting customer relationships through personalized, impactful email campaigns. From newsletters to drip campaigns, we create content that converts.'
    },
    {
      image: digitalMarketingImg6,
      title: 'App Store Optimization (ASO)',
      description: 'Optimize your mobile app for app stores like Google Play and Apple\'s App Store, ensuring higher rankings, increased visibility, and more downloads.'
    },
    {
      image: digitalMarketingImg7,
      title: 'Online Reputation Management (ORM)',
      description: 'Manage your online reputation by monitoring, improving, and maintaining your brand\'s positive image. Address negative reviews and amplify customer trust.'
    },
    {
      image: digitalMarketingImg8,
      title: 'Content Writing',
      description: 'Deliver high-quality, SEO-friendly content tailored to your audience. From blog posts and website copy to social media captions, we ensure every word aligns with your brand voice.'
    }
  ];

  const getServicePageData = async () => {
    try {
      const payload = {
        slug: params?.slug
      };
      const response = await axios.post(`${BASE_URL}/servicedetail`, payload);
      setServiceData(response.data.data);
    } catch (error) {
      console.error('Error fetching service data:', error);
    }
  };

  useEffect(() => {
    if (params?.slug) {
      getServicePageData();
    }
  }, [params?.slug]);

  useEffect(() => {
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      setShowSlider(serviceData?.blogs?.length >= 2);
    } else {
      setShowSlider(serviceData?.blogs?.length >= 4);
    }
  }, [serviceData]);


  // if (!serviceData) {
  //   return <div className="loading">Loading...</div>;
  // }

  if (!serviceData) {
    return (
      <div className="parallax-container skeleton-page">
        {/* Background Skeleton */}
        <div className="background skeleton-bg" />

        {/* White overlay skeleton */}
        <div className="white-overlay">
          <div className="content">
            <div className="skeleton skeleton-title" />
            <div className="skeleton skeleton-subtitle" />
            <div className="skeleton skeleton-subtitle small" />

            <div className="button" style={{ marginTop: "20px" }}>
              <div className="skeleton skeleton-btn" />
            </div>
          </div>
        </div>

        {/* Our Designing Process skeleton */}
        <div className="our-designing-process">
          <div className="skeleton skeleton-heading" />
          <div className="skeleton skeleton-para" />

          <div className="cards">
            {[1, 2, 3].map((_, i) => (
              <div className="card" key={i}>
                <div className="skeleton skeleton-icon" />
                <div className="skeleton skeleton-card-title" />
                <div className="skeleton skeleton-card-text" />
                <div className="skeleton skeleton-card-text short" />
              </div>
            ))}
          </div>
        </div>

        {/* Why Choose section skeleton */}
        <div className="why-choose-omkatech">
          <div className="left-content">
            <div className="skeleton skeleton-heading" />
            <div className="skeleton skeleton-para" />
            <div className="skeleton skeleton-para short" />
          </div>

          <div className="right-img">
            <div className="skeleton skeleton-img" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="parallax-container">
      <Helmet>
        <title>{service?.title || 'Omka Tech Services'}</title>
        <meta name="description" content={service?.description || 'Default service description...'} />
        <link rel="canonical" href={service?.link} />
      </Helmet>

      {/* The fixed background image */}
      <div
        className="background"
        style={{ backgroundImage: `url('${serviceData?.file_path}${serviceData?.backgroundimage}')` }}
      />

      {/* White overlay section with text */}
      <div className="white-overlay">
        <div className="content">
          <h1 style={{ backgroundImage: `url('${serviceData?.file_path}${serviceData?.backgroundimage}')` }}>
            {serviceData?.title}
          </h1>
          <p>{serviceData?.subtitle}</p>
          <Link className="portfolio-page" to="/contact-us">
            <div className="button">
              <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span>BOOK A FREE CONSULTATION</span>
                <span className="img">
                  {isHovered ? (
                    <img src={GradientArrowIcon} alt="gradient-icon" />
                  ) : (
                    <img src={ArrowIcon} alt="arrow-icon" />
                  )}
                </span>
              </button>
            </div>
          </Link>
        </div>
      </div>

      {/* Additional scrolling content */}
      <div className="scroll-content" />

      {/* Our Designing Process */}
      {serviceData?.workingprocess && (
        <div className="our-designing-process">
          <h2>{serviceData.workingprocess.title}</h2>
          <p>{serviceData.workingprocess.sub_title}</p>
          <div className="cards">
            {serviceData.workingprocess.workingprocesspoints?.map((designing, index) => (
              <div className="card" key={index}>
                <img src={designing.path + designing.icon} alt={designing.title} />
                <h4>{designing.title}</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(designing?.points)
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Digital Marketing Services Section */}
      {serviceData?.title === 'Digital Marketing' && (
        <div className="our-digital-marketing-services">
          <h2>OUR {serviceData.title} SERVICES</h2>
          <p>
            We offer a comprehensive suite of digital marketing services to help you dominate the online
            landscape and achieve your business goals.
          </p>
          <div className="cards">
            {digitalMarketingServices.map((services, index) => (
              <div className="card" key={index}>
                <img src={services.image} alt={services.title} />
                <h4>{services.title}</h4>
                <p>{services.description}</p>
              </div>
            ))}
          </div>
          <Link to={"/seo-case-study"}>
          <div className="button">
              <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span>SEO CASE STUDY</span>
                <span className="img">
                  {isHovered ? (
                    <img src={GradientArrowIcon} alt="gradient-icon" />
                  ) : (
                    <img src={WhiteArrowIcon} alt="arrow-icon" />
                  )}
                </span>
              </button>
            </div>
          </Link>
        </div>
      )}

      {/* Tools Used Section */}
      {serviceData?.tool_and_technology?.length > 0 && (
        <div className="tools-used">
          <h2>Tools We Use for Ideation and {serviceData.title}</h2>
          <div className="tools-icons">
            {serviceData.tool_and_technology.map((tool, index) => (
              <div className="icon" key={index}>
                <img
                  src={`${tool.image_path}${tool.image}`}
                  alt={`Tool ${index + 1}`}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Why Choose OmkaTech */}
      <div className="why-choose-omkatech">
        <h3 className="responsive-why-choose-title">{serviceData?.why_choose_title}</h3>
        <div className="left-content">
          <h3 className="why-choose-title">{serviceData?.why_choose_title}</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(serviceData?.why_choose_description)
            }}
          />
        </div>
        <div className="right-img">
          <img
            src={`${serviceData?.file_path}${serviceData?.why_choose_image}`}
            alt="Why choose us"
          />
        </div>
      </div>

      <OurClients checkcolor="color" />

      {/* Related Articles */}
      {serviceData?.blogs?.length > 0 && (
        <div className="realted-articles">
          <h2>RELATED ARTICLES</h2>
          {showSlider ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              loop={true}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 15 },
                1024: { slidesPerView: 3, spaceBetween: 20 }
              }}
              className="slide-images-swiper"
            >
              {serviceData.blogs.map((articlesData, index) => (
                <SwiperSlide key={index}>
                  <div
                    onClick={() => navigate(`/blog/${articlesData.slug}`)}
                    className="slide"
                    style={{
                      backgroundImage: `url('${articlesData?.file_path}${articlesData?.thumbnail}')`
                    }}
                  >
                    <div className="heading">
                      <h5>{articlesData?.title}</h5>
                      <p>{getPlainText(articlesData?.description).slice(0, 40) + '...'}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="slide-images">
              {serviceData.blogs.map((articlesData, index) => (
                <div
                  key={index}
                  onClick={() => navigate(`/blog/${articlesData.slug}`)}
                  className="slide"
                  style={{
                    backgroundImage: `url('${articlesData?.file_path}${articlesData?.thumbnail}')`
                  }}
                >
                  <div className="heading">
                    <h5>{articlesData?.title}</h5>
                    <p>{getPlainText(articlesData?.description).slice(0, 40) + '...'}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <Faq service_id={params?.slug} />

      {/* Connect with Expert */}
      <div className="bg">
        <div className="connect-with-expert">
          <h2>Product Design and Ideation Services</h2>
          <p>
            We ideate, design, and deliver seamless experiences by bridging the gap between your idea
            and the product
          </p>
          <Link to="/contact-us" className="portfolio-page">
            <div className="button">
              <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span>START YOUR PROJECT TODAY</span>
                <span className="img">
                  {isHovered ? (
                    <img src={GradientArrowIcon} alt="gradient-icon" />
                  ) : (
                    <img src={WhiteArrowIcon} alt="arrow-icon" />
                  )}
                </span>
              </button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServicePage;